import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import InfoSection from "./tenantInfo";
import LeaseSection from "./leaseSection";
import MaintainanceSection from "./maintainance";
import InfoCards from "../../../reusebale/cards";
import db from "../../../../db/index.json";
import TenantLoader from "../../../skeleton-loader/tennant-detail"

const LandlordDetail = ({ landlordInfo, onBack, onAction }) => {
  const { landlord } = db;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000);
  }, []);

  return (
    <div className="mt-4 h-full">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="Landlord Details"

        content={`${landlordInfo?.personalInformation?.firstName} ${landlordInfo?.personalInformation?.lastName}`}
        onBack={onBack}
      />
      {isLoading && <TenantLoader />}
      {!isLoading && (
        <div className="mt-4 h-full">
          <InfoSection tenantInfo={landlordInfo} />
          <LeaseSection landlordInfo={landlordInfo} />
          <MaintainanceSection landlordInfo={landlordInfo} />
          {/* <div className="flex flex-wrap mt-5" id="gk-cards">
          {landlord.cardData2.map((item, i) => (
            <InfoCards item={item} onTrigger={onAction} />
          ))}
        </div> */}
        </div>
      )}
    </div>
  );
};

export default LandlordDetail;
